import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'
import BlackChevronLeft from '../../../images/icon_chevron_left.svg'
import BlackChevronRight from '../../../images/icon_chevron_right.svg'
import CloseIcon from '../../../images/icon_times_black.svg'

export const TourStepContainer = styled.div`
  background: ${themeStyles.colors.white.main};
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 15px;
  min-width: 300px;
  max-width: 320px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const TourStepHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const TourStepTitle = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: ${themeStyles.colors.black.main};
  line-height: 1.45;
`

export const TourStepCloseButton = styled.button`
  background-color: transparent;
  background-image: url('${CloseIcon}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 14px;
  border: none;
  margin: -5px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${themeStyles.colors.lightGreys[1].main};
  }
  
  &:focus {
    outline: 2px solid ${themeStyles.colors.accentColors.primary.main};
    outline-offset: 2px;
  }
`

export const TourStepContent = styled.div`
  font-size: ${brandConfig.fonts.text.body?.size?.desktop};
  line-height: 1.5;
  color: ${themeStyles.colors.darkGreys[4].main};
  
  ${themeMedia.mobile`
    font-size: ${brandConfig.fonts.text.body?.size?.mobile};
  `}
`

export const TourStepProgress = styled.div`
  font-size: ${brandConfig.fonts.text.small?.size?.desktop || '12px'};
  color: ${themeStyles.colors.darkGreys[3].main};
  font-weight: 500;
  
  ${themeMedia.mobile`
    font-size: ${brandConfig.fonts.text.small?.size?.mobile || '12px'};
  `}
`

export const TourStepFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;  
  ${themeMedia.mobile`
    flex-direction: column-reverse;
    gap: 8px;
  `}
`

export const TourStepButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`

export const TourStepButton = styled.button`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 18px;
  background-color: ${themeStyles.colors.lightGreys[1].main};
  background-image: ${props => 
    props.$direction === 'left' 
      ? `url('${BlackChevronLeft}')` 
      : `url('${BlackChevronRight}')`
  };
  background-position: center;
  background-repeat: no-repeat;
  background-size: 8px;
  border: none;
  transition: all 0.2s ease;
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`